export default __webpack_public_path__ + "static/media/gf-topic1.1155b9ec.png";